import React, { Component } from 'react';
import translate from 'react-i18next/dist/commonjs/translate';
import Button from 'antd/lib/button';
import Input from 'antd/lib/input';
import Select from 'antd/lib/select';
import Form from 'antd/lib/form';
import rules from '../../../common/rules/rules';
import api from '../../payments/api';
import Spin from 'antd/lib/spin';
import message from 'antd/lib/message';
import { connect } from 'react-redux';
import { selectIsAdmin } from '../../auth/ducks';
import { bindActionCreators } from 'redux';
import { selectFeeAccountAmount, fetchSystemFeeAccountAmountActions } from '../../account-management/ducks';
import { currencyFormatter } from '../../../common/utils/helpers'

const { Option } = Select;

const formItemLayout = {
    labelCol: {
      xs: {
        span: 9,
      },
      sm: {
        span: 6,
      },
    },
    wrapperCol: {
      xs: {
        span: 15,
      },
      sm: {
        span: 14,
      },
    },
  };

const tailFormItemLayout = {
    wrapperCol: {
        span: 4,
        offset: 4,
    },
};

const mapStateToProps = state => ({
    isAdmin: selectIsAdmin(state),
    feeAccountAmount: selectFeeAccountAmount(state)
  });
  
const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
    {
        fetchSystemFeeAccountAmount: fetchSystemFeeAccountAmountActions.request,
    },
    dispatch
    ),
});

@connect(mapStateToProps, mapDispatchToProps)
@translate()
@Form.create()
export default class ProvisionFeeWithdraw extends Component {

    componentDidMount(){
        this.props.actions.fetchSystemFeeAccountAmount()
    }

    state = {
        inProcess: false
    }

    componentDidUpdate(){
        this.props.actions.fetchSystemFeeAccountAmount()
    }

    handleSubmit = e => {
        e.preventDefault();
        const { t, form } = this.props;

        form.setFieldsValue({ 
            amount: form.getFieldValue('amount').replace(',','.')
        });
        form.validateFields((err, values) => {
            if (!err) {
                this.setState({
                    inProcess: true
                });
                api.withdrawProvisionFees(values).then((response) => {
                    if (response.ok){
                        message.success(t('Výber bol úspešne zrealizovaný'));
                    }
                }).finally(() => {
                    this.setState({
                        inProcess: false
                    });
                });
            }
        }); 
    };

    render() {
        const { feeAccountAmount, t } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <Spin spinning={this.state.inProcess}>
                <Form.Item {...formItemLayout} label={t('Hodnota poplatkového účtu')}>
                    <span>{currencyFormatter(feeAccountAmount)}</span>
                </Form.Item>

                <Form onSubmit={this.handleSubmit} style={{maxWidth:'40%'}}>
                    <Form.Item {...formItemLayout} label={t('Suma')}>
                        {getFieldDecorator('amount', { rules: [
                            ...rules.required,
                            rules.positiveNumber,
                            rules.currencyChecker,
                        ] , initialValue: "", })(
                            <Input size="default" placeholder={t('Suma')}/>
                        )}
                    </Form.Item>
                    <Form.Item {...formItemLayout} label={t('Variabilný symbol')}>
                        {getFieldDecorator('variableSymbol', { 
                                rules: [
                                    rules.maxLength(7),
                                    rules.numbersOnly
                                ],
                                initialValue: "" 
                            })(
                            <Input size="default" placeholder={t('Variabilný symbol')} />
                        )}
                    </Form.Item>

                    <Form.Item {...formItemLayout} label={t('Typ transakcie')}>
                        {getFieldDecorator('transactionType', { rules: rules.required, initialValue: "" })(
                            <Select size="default" placeholder={t('Vybrať typ transakcie')}>
                                <Option key={'FEE_WITHDRAWAL'} value={'FEE_WITHDRAWAL'}>
                                    {t('Výber poplatkov')}
                                </Option>
                                <Option key={'INSURANCE_WITHDRAWAL'} value={'INSURANCE_WITHDRAWAL'}>
                                    {t('Výber poistenie')}
                                </Option>
                            </Select>
                        )}
                    </Form.Item>

                    <Form.Item {...tailFormItemLayout}>
                        <Button size="default" type="primary" htmlType="submit">
                            {t('Vybrať')}
                        </Button>
                    </Form.Item>
                </Form>
            </Spin>
        );
    }
};


// WEBPACK FOOTER //
// ./src/features/admin/components/ProvisionFeeWithdraw.js